// extracted by mini-css-extract-plugin
export default {"fr-view":"Standalone_fr-view__gB7OG","droppable":"Standalone_droppable__JUwAG","isDraggingOver":"Standalone_isDraggingOver__1vSC5"};